import RootStatusBadge from '@/components/root/RootStatusBadge';
import { Text, VStack } from '@/components/sgBootstrapReactWrapper';
import type { PersonsRolesResponse } from '@/model/Person';
import { isDefined } from '@/utils/assertions';
import { getTheme } from '@/utils/theme';
import { Link } from '@tanstack/react-router';
import { FormattedMessage } from 'react-intl';
import { v4 } from 'uuid';

type PartiesDrawerBodyProps = {
  personsRolesData: PersonsRolesResponse;
  onRootClick: (rootId: string) => void;
};

const RolesDrawerBody = ({ personsRolesData, onRootClick }: PartiesDrawerBodyProps) => {
  const theme = getTheme();

  return (
    <VStack>
      <Text className="display-5 my-4 mx-3">
        <FormattedMessage id="roles.drawer.body.roles" />
      </Text>
      <div className="container-xxl" style={{ overflow: 'auto', height: '70vh' }}>
        <table className="table">
          <thead
            style={{
              position: 'sticky',
              backgroundColor: theme === 'dark' ? '#333333' : 'white',
              top: 0,
              zIndex: 10,
            }}
            className="thead-light"
          >
            <tr>
              <th className="text-secondary p-1">
                <FormattedMessage id="roles.drawer.body.root" />
              </th>
              <th className="text-secondary p-1">
                <FormattedMessage id="roles.drawer.body.rootName" />
              </th>
              <th className="text-secondary p-1">
                <FormattedMessage id="roles.drawer.body.rootStatus" />
              </th>
              <th className="text-secondary p-1">
                <FormattedMessage id="roles.drawer.body.role" />
              </th>
              <th className="text-secondary p-1">
                <FormattedMessage id="roles.drawer.body.linkStatus" />
              </th>
            </tr>
          </thead>

          <tbody>
            {personsRolesData?.roles?.map(({ linkStatus, role, rootId, rootName, rootStatus }) => (
              <tr data-e2e="roles-roles-row" key={v4()}>
                <td
                  data-e2e="roles-roles-rootId"
                  className="p-1"
                  style={{
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                  onClick={() => rootId && onRootClick(rootId)}
                >
                  {rootId}
                </td>
                <td data-e2e="roles-roles-rootName" className="p-1">
                  {rootName}
                </td>
                <td data-e2e="roles-roles-status" className="p-1">
                  {isDefined(rootStatus) ? <RootStatusBadge rootStatus={rootStatus} /> : null}
                </td>
                <td data-e2e="roles-roles-role" className="p-1">
                  <FormattedMessage id={`roles.drawer.body.role.${role}`} />
                </td>
                <td data-e2e="roles-roles-linkStatus" className="p-1">
                  {isDefined(linkStatus) ? <RootStatusBadge rootStatus={linkStatus} /> : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </VStack>
  );
};

export default RolesDrawerBody;
